import APIService from './APIService'

const api = APIService()

export const listMyEstates = (page = 1) => api.get(`/estates?page=${page}&per_page=24`)
export const searchEstates = query => api.get(`/estates?search=${encodeURIComponent(query)}&per_page=24`)
export const getEstate = id => api.get(`/estates/${id}`)
export const createEstate = payload => api.post('/estates', payload)
export const listPortfolioEstates = portfolioId => api.get(`/portfolios/${portfolioId}/estates`)
export const createPortfolioEstate = (portfolioId, payload) => api.post(`/portfolios/${portfolioId}/estates`, payload)
export const updateEstate = ({ id, ...payload }) => api.patch(`/estates/${id}`, payload)
export const deleteEstate = id => api.delete(`/estates/${id}`)
export const attachBps = ({ id, buildingPassportIds }) =>
  api.post(`/estates/${id}/building-passports`, { building_passport_ids: buildingPassportIds })
export const detachBp = ({ id, bpId }) => api.delete(`/estates/${id}/building-passports/${bpId}`)
export const attachToPortfolio = ({ id, portfolioId }) =>
  api.post(`/estates/${id}/portfolio`, { portfolio_id: portfolioId })
export const detachFromPortfolio = id => api.delete(`/estates/${id}/portfolio`)

export const getEstateSafetyRoles = id => api.get(`/estates/${id}/safety-roles`)

export const listEstateUsers = id => api.get(`/estates/${id}/users`)
export const getEstateAccessTree = id => api.get(`/estates/${id}/tree`)
export const assignEstateUser = ({ id, userId, email, relationType, expiresAt, firstName, lastName }) =>
  api.post(`/estates/${id}/users`, { user_id: userId || null, email: email || null, relation_type: relationType, expires_at: expiresAt || null, first_name: firstName || null, last_name: lastName || null })
export const updateEstateUser = ({ id, estateUserId, relationType }) =>
  api.patch(`/estates/${id}/users/${estateUserId}`, { relation_type: relationType })
export const revokeEstateUser = ({ id, estateUserId }) =>
  api.delete(`/estates/${id}/users/${estateUserId}`)

export const removeUserFromEstate = ({ id, userId }) =>
  api.post(`/estates/${id}/access/remove-user`, { userId })

export const inviteEstateUser = ({ id, email, relationType, expiresAt, firstName, lastName, phoneNumber }) =>
  api.post(`/estates/${id}/invitations`, {
    email,
    relation_type: relationType,
    expires_at: expiresAt || null,
    first_name: firstName || null,
    last_name: lastName || null,
    phone_number: phoneNumber || null,
  })
export const listEstateInvitations = id => api.get(`/estates/${id}/invitations`)
export const deleteEstateInvitation = ({ id, invitationId }) =>
  api.delete(`/estates/${id}/invitations/${invitationId}`)

export const listEstateRevokedUsers = id => api.get(`/estates/${id}/revoked-users`)
export const listEstateAccessRequests = id => api.get(`/estates/${id}/access-requests`)
export const requestEstateAccess = ({ id, relationType }) =>
  api.post(`/estates/${id}/access-requests`, { relation_type: relationType })
export const acceptEstateAccessRequest = ({ id, requestId }) =>
  api.post(`/estates/${id}/access-requests/${requestId}/accept`)
export const deleteEstateAccessRequest = ({ id, requestId }) =>
  api.delete(`/estates/${id}/access-requests/${requestId}`)

export const listEstateDomainGrants = id => api.get(`/estates/${id}/domain-grants`)
export const getEstateDomainGrantMembers = (id, grantId) => api.get(`/estates/${id}/domain-grants/${grantId}/members`)
export const previewEstateDomainGrant = (id, { domain, relationType }) => api.get(`/estates/${id}/domain-grants/preview`, { params: { domain, relation_type: relationType } })
export const addEstateDomainGrant = (id, body) => api.post(`/estates/${id}/domain-grants`, body)
export const removeEstateDomainGrant = (id, grantId) => api.delete(`/estates/${id}/domain-grants/${grantId}`)
export const restrictEstateDomainUser = (id, userId) => api.post(`/estates/${id}/domain-restrictions`, { user_id: userId })
export const liftEstateDomainRestriction = (id, userId) => api.delete(`/estates/${id}/domain-restrictions/${userId}`)

export const getEstateActivity = ({ estateId, page = 1, limit = 25 }) =>
  api.get(`/estates/${estateId}/activity?page=${page}&limit=${limit}`)
